import { OCC_USER_ID_ANONYMOUS, UserIdService } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { MbStateWithWishlistContext, MbWishlistSelectors } from '../store'
import { AddEntryToWishlist, LoadDefaultWishlist, RemoveEntryFromWishlist } from '../store/actions/wishlist.actions'
import { filter, shareReplay, switchMap, take, tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class MbWishListService {

  isWishlistLoaded = false

  constructor (protected store: Store<MbStateWithWishlistContext>,
               protected userIdService: UserIdService) {
    this.getDefaultWishlist().pipe(take(1)).subscribe()
  }

  getDefaultWishlist () {
    return this.userIdService.getUserId().pipe(
      tap(userId => {
        if (userId !== OCC_USER_ID_ANONYMOUS) {
          this.loadWishList(userId)
          this.isWishlistLoaded = true
        }
      }),
      switchMap(() => this.store.select(MbWishlistSelectors.getDefaultWishlist)),
      shareReplay(1)
    )
  }

  loadWishList (userId: string) {
    this.store.dispatch(new LoadDefaultWishlist({ userId: userId }))
  }

  addEntry (productCode: string) {
    this.userIdService.getUserId().pipe(
      take(1),
      tap(userId => this.store.dispatch(new AddEntryToWishlist({ productCode: productCode, userId: userId })))
    ).subscribe()
  }

  removeEntry (productCode: string) {
    this.userIdService.getUserId().pipe(
      take(1),
      tap(userId => this.store.dispatch(new RemoveEntryFromWishlist({ productCode: productCode, userId: userId })))
    ).subscribe()
  }

  isProductInWishlist (productCode: string | undefined) {
    return productCode && this.store.select(MbWishlistSelectors.getDefaultWishlist).pipe(
      filter(wishlist => !!wishlist?.entries?.find(entry => entry.product?.code === productCode))
    )
  }
}
